WL.registerComponent('link', {
    url: {type: WL.Type.String, default: "https://wonderlandengine.com/vr" },
    openInNewTab: {type: WL.Type.Bool, default: true },
}, {
    start: function() {
        const target = this.object.getComponent('cursor-target') || this.object.addComponent('cursor-target');

        target.addClickFunction(() => {
            if(this.openInNewTab) {
                window.open(this.url, "_blank");
            } else {
                window.location = this.url;
            }
        });
    }
});

WL.registerComponent('back-link', {}, {
    start: function() {
        const target = this.object.getComponent('cursor-target') || this.object.addComponent('cursor-target');
        target.addClickFunction(() => {
            history.back();
        });
    }
});
